module.exports = __webpack_public_path__ + "img/like.803cd7b5.svg";